export const SUPPORTED_LOCALES = ["th", "en"];
export const UI_LANGUAGE_STORAGE_KEY = "invictus-tax-law-ui-language";

export function normalizeLocale(value, fallback = "th") {
  const candidate = String(value || "").trim().toLowerCase().split(/[-_]/)[0];
  return SUPPORTED_LOCALES.includes(candidate) ? candidate : fallback;
}

export function localeFromPath(pathname = "") {
  const first = String(pathname || "")
    .split("/")
    .filter(Boolean)[0]
    ?.toLowerCase();
  return SUPPORTED_LOCALES.includes(first) ? first : "";
}

export function localePath(locale, pathname = "/") {
  const nextLocale = normalizeLocale(locale);
  const current = String(pathname || "/");
  const withoutLocale = current.replace(/^\/(?:th|en)(?=\/|$)/i, "") || "/";
  return `/${nextLocale}${withoutLocale === "/" ? "/" : withoutLocale}`;
}

export function deviceLocale(navigatorLike = globalThis.navigator) {
  const languages = navigatorLike?.languages?.length
    ? navigatorLike.languages
    : [navigatorLike?.language];
  return languages.some((value) => String(value || "").toLowerCase().startsWith("th"))
    ? "th"
    : "en";
}

export function savedLocale(storage = globalThis.localStorage) {
  try {
    return normalizeLocale(storage?.getItem(UI_LANGUAGE_STORAGE_KEY), "");
  } catch {
    return "";
  }
}

/**
 * Route locale is authoritative for /th/ and /en/. The root route is only a
 * chooser: an explicit legacy ui_lang, saved preference, then device locale.
 */
export function resolveLocale({ pathname = "/", search = "", storage, navigator } = {}) {
  const pathLocale = localeFromPath(pathname);
  if (pathLocale) return { locale: pathLocale, source: "path" };
  const params = new URLSearchParams(search);
  const legacy = normalizeLocale(params.get("ui_lang"), "");
  if (legacy) return { locale: legacy, source: "legacy-query" };
  const saved = savedLocale(storage);
  if (saved) return { locale: saved, source: "saved" };
  return { locale: deviceLocale(navigator), source: "device" };
}

export function canonicalizeLocaleUrl(locationLike, locale) {
  const url = new URL(String(locationLike?.href || locationLike || "/"), "http://localhost");
  const nextPath = localePath(locale, url.pathname);
  url.pathname = nextPath;
  url.searchParams.delete("ui_lang");
  return url;
}

